import type { ImageJob } from '../types'
import { UploadZone } from './UploadZone'

interface Props {
  jobs: ImageJob[]
  selectedId?: string
  onSelect: (id: string) => void
  onRemove: (id: string) => void
  onFiles: (files: File[]) => void
}

const phaseText: Record<ImageJob['phase'], string> = {
  idle: '待機', decoding: '読込中', face: '顔', ocr: '文字', barcode: 'コード',
  review: '確認', exporting: '保存中', done: '保存済み', error: '要確認',
}

export function QueueSidebar({ jobs, selectedId, onSelect, onRemove, onFiles }: Props) {
  return (
    <aside className="asset-rail" aria-label="画像一覧">
      <div className="asset-rail-heading"><span>写真</span><strong>{jobs.length}枚</strong></div>
      <UploadZone compact onFiles={onFiles} />
      <ul className="asset-list">
        {jobs.map((job, index) => (
          <li key={job.id} className={job.id === selectedId ? 'selected' : ''}>
            <button type="button" className="asset-item" onClick={() => onSelect(job.id)} title={job.name}>
              <span className="asset-thumb"><img src={job.objectUrl} alt="" /><i>{index + 1}</i></span>
              <span className={`asset-state phase-${job.phase}`}>{job.reviewConfirmed && job.phase === 'review' ? '確認済み' : phaseText[job.phase]}</span>
            </button>
            <button type="button" className="asset-remove" aria-label={`${job.name}を削除`} onClick={() => onRemove(job.id)}>削除</button>
          </li>
        ))}
      </ul>
    </aside>
  )
}
